<template>
  <div class="cambio-pass">
    <Titulo titulo="Cambio de contraseña" />
    <div class="margin-cambiar-pass">
      <b-row>
        <b-col cols="12" md="6">
          <div class="panel1">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <div>
                <h3 class="color-secundary">Renueve su contraseña</h3>
                <p class="mb-4 text-justify">
                  Ingrese la nueva contraseña y realice la confirmación
                </p>
              </div>
              <b-form-group label="Usuario" label-for="usuario" :label-cols="4">
                <b-form-input
                  id="usuario"
                  type="text"
                  v-model="usuario"
                  disabled
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Contraseña"
                label-for="password"
                :label-cols="4"
              >
                <b-form-input
                  id="password"
                  type="password"
                  v-model="password"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Confirmar"
                label-for="confirmar"
                :label-cols="4"
              >
                <b-form-input
                  id="confirmar"
                  type="password"
                  v-model="confirmar"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label="Porcentaje de seguridad"
                label-for="progress"
                :label-cols="4"
                v-if="false"
              >
                <b-progress :max="max" id="progress" class="mt-2 h-90">
                  <b-progress-bar
                    :value="value"
                    :label-html="`${value}%`"
                    variant="dark"
                    v-if="value > 0 && value <= 30"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="value"
                    :label-html="`${value}%`"
                    variant="danger"
                    v-if="value > 30 && value <= 60"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="value"
                    :label-html="`${value}%`"
                    variant="warning"
                    v-if="value > 60 && value <= 90"
                  ></b-progress-bar>
                  <b-progress-bar
                    :value="value"
                    :label-html="`${value}%`"
                    variant="success"
                    v-if="value > 90 && value <= 100"
                  ></b-progress-bar>
                </b-progress>
              </b-form-group>

              <div class="text-right">
                <img
                  v-if="loading"
                  class="loading"
                  src="@/assets/images/loader.gif"
                  alt
                />
                <b-button
                  class="button-carga"
                  style="margin: 2% 2% 2% 2%"
                  type="reset"
                  >Borrar</b-button
                >
                <b-button
                  class="button-carga"
                  style="margin: 2% 0% 2% 2%"
                  type="submit"
                  :disabled="loading"
                  >Enviar</b-button
                >
              </div>
            </b-form>
          </div>
        </b-col>

        <!-- Panel Derecho -->

        <b-col cols="12" md="6">
          <div class="recomen-cambio-pass p-4">
            <b-row>
              <b-col class="margin-izquierdo">
                <div class="ancho-recomendaciones">
                  <b class="color-secundary" style="font-size: 24px">
                    <b-img
                      src="/images/pages/novedades.svg"
                      height="60"
                      class="mr-2"
                    ></b-img>
                    <br />Recomendaciones para crear una contraseña segura y
                    fácil de recordar
                  </b>
                  <br />
                  <br />1. Piense en una frase que pueda recordar. Ejemplo: mi
                  gato Simón tiene 2 años y es amarillo. <br />2. Use la primera
                  letra de cada palabra de la frase que ha creado. Ejemplo:
                  mgst2ayea <br />3. Aumente la complejidad combinando
                  mayúsculas y minúsculas. Ejemplo: MgSt2AyEa <br />4. Reemplace
                  alguna letra por un carácter. Ejemplo: MgSt2AyE@ <br />5. Debe
                  tener minimo 14 caracteres combinando letras y números
                  <br />
                </div>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import SelectContrasena from "@/data/SelectContrasena.json";

export default {
  name: "CambioPassword",
  data() {
    return {
      SelectContrasena: SelectContrasena,
      selectPass: "",
      value: 95,
      max: 100,
      usuario: "",
      password: null,
      confirmar: null,
      usuario_id: null,
      loading: false,
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    Recomendaciones: () => import("@/containers/layout/Recomendaciones.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
  },
  methods: {
    async onSubmit() {
      let password = this.password;
      let confirmar = this.confirmar;
      let id_usuario = this.usuario_id;

      if (password != confirmar) {
        this.$toasted.error("Las contraseñas no coinciden", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000,
        });
        return false;
      }
      if (String(password).length < 14) {
        this.$toasted.error(
          "La contraseña debe contener minimo 14 caracteres",
          {
            theme: "toasted-primary",
            position: "top-right",
            duration: 10000,
          }
        );
        return false;
      }
      this.loading = true;
      try {
        let response = await this.$store.state.api
          .put("usuario/contrasenia_portal", {
            id: this.usuario_id,
            password: this.password,
            origen: 'portal'
          })
          .then((response) => {
            if (response) {
              this.$toasted.success("Su contraseña fue actualizada con éxito", {
                theme: "toasted-primary",
                position: "top-right",
                duration: 10000,
              });
              this.$store.commit("user/SET_CAMBIAR_CLAVE", false);
              this.onReset();
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$toasted.error(err.response.data.errors.password.toString(), {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
            this.loading = false;
          });
      } catch (err) {}
    },
    onReset(evt) {
      (this.usuario = ""), (this.password = ""), (this.confirmar = "");
    },
  },
  mounted() {
    this.usuario =
      this.$store.state.user.user.nombres +
      " " +
      this.$store.state.user.user.apellidos;
    this.usuario_id = this.$store.state.user.user.id;
  },
};
</script>